import React from 'react';
import styled from 'styled-components';

const InstructorsSection = styled.section`
  padding: ${({ theme }) => `${theme.spacing['2xl']} 0`};
  background-color: ${({ theme }) => theme.colors.white};
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
  
  h2 {
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.125rem;
    max-width: 600px;
    margin: 0 auto;
    color: ${({ theme }) => theme.colors.gray};
  }
`;

const InstructorsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 3rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const InstructorCard = styled.div`
  background: white;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: ${({ theme }) => theme.transitions.default};
  border: 2px solid transparent;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;

const InstructorImage = styled.div<{ image: string }>`
  width: 100%;
  height: 300px;
  background: ${({ image }) => `url(${image}) center/cover no-repeat`};
  position: relative;
  filter: grayscale(100%);
  transition: ${({ theme }) => theme.transitions.default};
  
  ${InstructorCard}:hover & {
    filter: grayscale(0%);
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(0,0,0,0.2) 0%, rgba(255,107,107,0.1) 100%);
  }
`;

const InstructorContent = styled.div`
  padding: 2rem;
`;

const InstructorName = styled.h3`
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1.5rem;
`;

const InstructorRole = styled.p`
  color: ${({ theme }) => theme.colors.accent};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
`;

const InstructorDescription = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const InstructorSpecialties = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

const SpecialtyTag = styled.span`
  background: ${({ theme }) => theme.colors.black};
  color: white;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  transition: ${({ theme }) => theme.transitions.default};
  
  &:hover {
    background: ${({ theme }) => theme.colors.accent};
  }
`;

const InstructorStats = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
  border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

const StatItem = styled.div`
  text-align: center;
  
  .number {
    font-size: 1.5rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.accent};
    display: block;
  }
  
  .label {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.gray};
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`;

const instructors = [
  {
    id: 1,
    name: "Nastya Rogachova",
    role: "Instruktor Modern & High Heels",
    image: "https://images.unsplash.com/photo-1642157690261-d8b52223c9fa?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Nastya to pionierka stylu modern w Zielonej Górze, która 8 lat temu jako pierwsza poprowadziła zajęcia w tym stylu. Szkoliła się pod okiem tancerzy z Broadwayu i znanych choreografów produkcji telewizyjnych w Polsce. Jako doświadczona tancerka formacyjna zna taniec od podstaw.",
    specialties: ["Modern", "High Heels", "Commercial", "Cheerleading", "Hip Hop", "Waacking"],
    experience: "8+ lat",
    groups: "Średnio zaawansowane"
  },
  {
    id: 2,
    name: "Oliwia Madej",
    role: "Instruktor Modern - Początkujące",
    image: "https://images.unsplash.com/photo-1518834107812-67b0b7c58434?ixlib=rb-4.0.3&auto=format&fit=crop&w=1435&q=80",
    description: "Oliwia rozpoczęła swoją przygodę z tańcem w 2013 roku i od najmłodszych lat wiedziała, że taniec to jej pierwsza miłość. Przez lata tańczyła w formacjach w kategorii modern, zajmując miejsca na podium w turniejach. Teraz dzieli się swoją pasją z innymi.",
    specialties: ["Modern", "Taniec Formacyjny", "Choreografia"],
    experience: "11+ lat",
    groups: "Dzieci i dorośli początkujący"
  },
  {
    id: 3,
    name: "Łukasz",
    role: "Trener Wzmacniający & Akrobatyka",
    image: "https://images.unsplash.com/photo-1583500178690-f7ff40d4a749?ixlib=rb-4.0.3&auto=format&fit=crop&w=1364&q=80",
    description: "Łukasz to trener z 9-letnim doświadczeniem, specjalizujący się w zajęciach wzmacniających i podstawach akrobatyki. Jego celem jest rozwinięcie siły, stabilizacji, gibkości i świadomości ciała u tancerzy, aby mogli bezpiecznie wykonywać coraz bardziej wymagające elementy.",
    specialties: ["Akrobatyka", "Trening Siłowy", "Stabilizacja", "Gibkość"],
    experience: "9+ lat",
    groups: "Wszyscy poziomy"
  }
];

const Instructors: React.FC = () => {
  return (
    <InstructorsSection id="instructors" className="section">
      <div className="container">
        <SectionHeader>
          <h2>Nasi Instruktorzy</h2>
          <p>
            Poznaj nasz zespół doświadczonych instruktorów, którzy poprowadzą Cię 
            przez fascynującą podróż w świecie tańca
          </p>
        </SectionHeader>
        
        <InstructorsGrid>
          {instructors.map((instructor) => (
            <InstructorCard key={instructor.id}>
              <InstructorImage image={instructor.image} />
              <InstructorContent>
                <InstructorName>{instructor.name}</InstructorName>
                <InstructorRole>{instructor.role}</InstructorRole>
                <InstructorDescription>{instructor.description}</InstructorDescription>
                
                <InstructorSpecialties>
                  {instructor.specialties.map((specialty, index) => (
                    <SpecialtyTag key={index}>{specialty}</SpecialtyTag>
                  ))}
                </InstructorSpecialties>
                
                <InstructorStats>
                  <StatItem>
                    <span className="number">{instructor.experience}</span>
                    <span className="label">Doświadczenie</span>
                  </StatItem>
                  <StatItem>
                    <span className="number">{instructor.groups}</span>
                    <span className="label">Grupy</span>
                  </StatItem>
                </InstructorStats>
              </InstructorContent>
            </InstructorCard>
          ))}
        </InstructorsGrid>
      </div>
    </InstructorsSection>
  );
};

export default Instructors;
